import React, { useEffect, useRef, useState } from 'react';

import { AssetManagementService } from '../../../services/asset-management-service';
import { container } from 'tsyringe';
import { useSharedState } from '../../../utils/helpers';
import { MediaType } from '../../../models/mediaClass';
import { SoundKey, SoundService } from '../../../services/sound-service';
import { ApiService } from '../../../services/api-service';

interface UploadAssetFileProps {
  mediaType: MediaType,
  accept: string,
  uploadStarted: any;
  uploadProgress?: any;
  uploadCompleted: any;
  uploadFailed?: any;
  fileError?: any;
}

const UploadAssetFile = (props: UploadAssetFileProps) => {

  const fileInputRef = useRef(null);

  const [soundService] = useState(container.resolve(SoundService));

  const [assetsService] = useState(container.resolve(AssetManagementService));
  const [apiService] = useState(container.resolve(ApiService));
  const [assets, setAssets] = useSharedState(assetsService.assetList$);
  const [uploadPercentage, setUploadPercentage] = useSharedState(assetsService.uploadPercentage$);
  const [uploadAssetKey, setUploadAssetKey] = useSharedState(assetsService.uploadAssetKey$);

  const [uploadAllowed, setUploadAllowed] = useState(true);
  const [currentUploadingType, setCurrentUploadingType] = useSharedState(assetsService.currentUploadingType$);

  const [selectedFile, setSelectedFile] = useState(null);
  const [isFilePicked, setIsFilePicked] = useState(false);
  const [isFileFailed, setIsFileFailed] = useState(false);
  const [isFileCompleted, setIsFileCompleted] = useState(false);

  const [sizeError, setSizeError] = useState(null);

  useEffect(() => {
    if (props.mediaType !== MediaType.FG_IMAGE) return;

    // do reload asset only for FG_IMAGE uploader -> it will handle others type as well
    // console.log('user assets', assets);
    if (assets && assets.length>0) {

      for(const asset of assets) {
        if (asset.type === 'video' && !asset?.properties?.duration) {
          // video still being processed
          setTimeout(() => {
            assetsService.refreshAsset(asset.id);
          }, 5000);
        }
      }
    }
  },  [assets]);

  useEffect(() => {
    if (props.mediaType !== currentUploadingType) return;
    console.log('UPLOAD 2', currentUploadingType);

    if (uploadAssetKey === assetsService.uploadFailed) {
      setUploadAssetKey(null);
      setUploadAllowed(true);
      console.log('UPLOAD 3 set currentUploadingType=NONE');

      setCurrentUploadingType(MediaType.NONE);
      setIsFilePicked(false);

      // something went wrong !! signal
      if (props.uploadFailed) {
        props.uploadFailed();
      }
      soundService.playSoundStart(SoundKey.Error);

    }
  }, [uploadAssetKey])

  const onFileError = () => {
    if (fileInputRef && fileInputRef.current) {
      fileInputRef.current.value = null;
    }
    props.fileError();
    setCurrentUploadingType(MediaType.NONE);
    setIsFilePicked(false);
    setUploadAllowed(true);

    soundService.playSoundStart(SoundKey.Error)

  }

  const uploadFile = (event) =>  {

    const MB = 1024 * 1204;
    const file = event.target.files[0];
    let type = props.mediaType;
    if (type === MediaType.BACKGROUND) {
      type = (file.type === 'image/png' || file.type === 'image/jpeg' || file.type === 'image/jpg') ? MediaType.BG_IMAGE : MediaType.BG_VIDEO;
    }

    if (props.fileError) {
      if (type === MediaType.FG_VIDEO) {
        if (file.size > 300 * MB ) {
          onFileError();
          return false;
        }
        if (file.type !== 'video/mp4' && file.type !== 'video/quicktime' && file.type !== 'video/ogg' ) {
          onFileError();
          return false;
        }
      } else if (type === MediaType.FG_IMAGE) {
        if (file.size > 20 * MB ) {
          onFileError();
          return false;
        }
        if (file.type !== 'image/png' && file.type !== 'image/jpeg' && file.type !== 'image/jpg' ) {
          onFileError();
          return false;
        }
      } else if (type === MediaType.BG_VIDEO) {
          if (file.size > 3 * MB ) {
            onFileError();
            return false;
          }
          if (file.type !== 'video/mp4' && file.type !== 'video/quicktime' && file.type !== 'video/ogg' ) {
            onFileError();
            return false;
          }
        } else if (type === MediaType.BG_IMAGE) {
          if (file.size > 20 * MB ) {
            onFileError();
            return false;
          }
          if (file.type !== 'image/png' && file.type !== 'image/jpeg' && file.type !== 'image/jpg' ) {
            onFileError();
            return false;
          }
        } else if (type === MediaType.LOGO) {
          if (file.size > 1 * MB ) {
            onFileError();
            return false;
          }
          if (file.type !== 'image/png' && file.type !== 'image/jpeg' && file.type !== 'image/jpg' ) {
            onFileError();
            return false;
          }
        }
    }

    setSelectedFile(file);
    setIsFilePicked(true);

    setUploadAllowed(false);
    setCurrentUploadingType(props.mediaType);

    if (props.uploadStarted) {
      props.uploadStarted(file);
    }

    // console.log(type);
    // setTimeout(async () => {
    //   await assetsService.uploadFile(file, type);
    // }, 100);

    // DEMO
    setTimeout(() => {
      setUploadAssetKey(null);
      setUploadAllowed(true);
      setCurrentUploadingType(MediaType.NONE);
      setIsFilePicked(false);

      if (props.uploadFailed) {
        props.uploadFailed();
      }
    }, 2000);

    return false;
  }

  useEffect(() => {

    if (props.mediaType !== currentUploadingType) return;
    console.log('UPLOAD 4', currentUploadingType);

    if (uploadPercentage < 100) {
      // still in progress
      if (props.uploadProgress) {
        props.uploadProgress(uploadPercentage);
      }
    } else {
      setIsFileCompleted(true);
      setUploadAllowed(true);

      if (props.uploadCompleted) {
        props.uploadCompleted();
      }

      setTimeout(() => {
        setIsFileCompleted(false);
        setUploadPercentage(0);
        setIsFilePicked(false);
        assetsService.loadAssets();
        console.log('UPLOAD 5 set currentUploadingType=NONE');
        setCurrentUploadingType(MediaType.NONE);
        }, 3000);
    }

  }, [uploadPercentage])

  useEffect(() => {
    // hide "+" btn is upload in progress
    console.log('UPLOAD 6', currentUploadingType);

    setUploadAllowed(currentUploadingType === MediaType.NONE);
  }, [currentUploadingType])

  const toggleRegisterPopup = () => {
    apiService.toggleRegisterPopup();
  }

  return (
    <>
      <div className='ButtonAdd' onClick={() => toggleRegisterPopup()}></div>
    {/* { !isFilePicked && uploadAllowed &&
      <>
        <label htmlFor={"file-upload-" + props.mediaType} className="ButtonAdd">
        </label>
        <input id={"file-upload-" + props.mediaType} type="file" accept={props.accept} name={"file" + props.mediaType} style={{ display: "none" }} onChange={uploadFile} ref={fileInputRef}/>
      </>
    } */}

    </>
  )

}


export default UploadAssetFile;